import React, { Fragment, useState, useEffect } from 'react';
import { translate } from '../../../Services/translation';
import { get, post } from "../../../Services/http";
import { ValidatePhone } from '../../../Services/phonevalidation';

const GDPRContinueRegister = () => {
    const [phone, setphone] = useState('');
    const [registerPageUrl, setregisterPageUrl] = useState('');
    const [errorMessage, seterrorMessage] = useState(false);

   useEffect(() => {
            get(`/api/gdprapproval/registerpageurl`)  
            .then((response) =>  response.json())          
            .then((result) => {
                setregisterPageUrl(result ? result.value : "");
            });
    }, []);

    const ValidateAndRedirectToRegister = () => {
        if (ValidatePhone(phone)) {
            post(`/api/gdprapproval/checkifphoneisvalid`, {
                phoneNumber: phone,
              })
            .then((response) => response.json())
            .then((result) => {
                if (result.value !== "") {
                    location.href = `${registerPageUrl}&identity=${result.value}`;
                } else {
                    seterrorMessage(true);
                }
            });            
        } 
        else {
            seterrorMessage(true);  
        }              
    }

    return (
        <Fragment>            
            <div className='row'>
                <div className='column small-6'>
                    {translate("coptikk.adminportal.gdprapproval.registerheader")}
                </div>
            </div>            
            {errorMessage && <div className='codelogin__error'>
                {translate("coptikk.login.invalidphonenumber")}
            </div>
            }
            <div className='row'>
                <div className='column small-6'>
                    <label>{translate("coptikk.login.phone")}</label>
                    <input type="text" placeholder='xxxxxxxx' onChange={(e) => setphone(e.target.value)}></input>
                </div>
            </div>
            <div>
                <button className='button' onClick={() => ValidateAndRedirectToRegister()}>{translate("coptikk.gdprapproval.continueregister")}</button>
            </div>            
        </Fragment>
    )
}

export default GDPRContinueRegister;